<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { $router } from '@/router'
import { defaultServiceOptions } from '@/common/config'
import { NotificationService } from '@/services/NotificationService.js'
import { useCabinetUnits } from "@/composables/cabinet.js"
import { useAuthState } from '@/composables/auth'
import { useTranslate } from '@/composables/language'
import { dialog } from '@/common/dialog'
import { formatDate } from '@/common/format'
import Button from "@/components/Button.vue"

const showFirstLoginModal = ref(false);
const route = useRoute();
const { t } = useTranslate();
let notificationService = null;

const notifications = ref([]);
const notificationIndex = ref(0);

const currentUserId = ref();
const currentCabinetId = ref();

const authStore = useAuthState();

function getCabinetId() {
  //Get cabinet definitions
  const { cabinetUnits } = useCabinetUnits();
  let localCabinets = cabinetUnits.value;

  if (!localCabinets || localCabinets.length == 0) {
    console.error("[catalog] No cabinet defined!");
    return;
  }

  //let cabinetIds = localCabinets.map(x => x.id);
  //isMultiCabinet.value = (localCabinets.length > 1);

  //Loop through each cabinet definition
  let cabinet = localCabinets.find(x => x.master) || localCabinets[0];
  return cabinet ? cabinet.id : null;
}

function checkFirstLogin() {
  //console.log("[notification] checkFirstLogin()");
  if (route.query.first === 'login') {
    showFirstLoginModal.value = true;
    return true;
  }
  return false;
}

async function loadNotifications() {
  try {
    //console.log("[notification] loadNotifications()");
    currentCabinetId.value = getCabinetId();
    currentUserId.value = authStore.userId.value;
    //console.log("[notification] cabinetId =", currentCabinetId.value, "userId =", currentUserId.value);

    const query = {
      target: "cabinet",
      userId: currentUserId.value,
      cabinetId: currentCabinetId.value,
      unread: true //TODO: does not work
    };

    if (!query.userId) {
      delete query.userId;
    }

    //Get notifications from database
    const result = await notificationService.getNotifications(query);

    let notificationsToDisplay = [ ];
    
    if (result?.items?.length > 0) {
      //Display only unread notifications
      for (let item of result.items) {
        let hasSeen = (item.viewers || []).find(x => x.userId == currentUserId.value);
        if (!hasSeen) {
          notificationsToDisplay.push(item);
        }
      }

      //First entered notification is displayed first
      notificationsToDisplay.reverse();
    }

    notifications.value = notificationsToDisplay;
  }
  catch (err) {
    console.error("[notifications] loadNotifications", err);
    dialog(err);
  }
}

onMounted(async () => {
  notificationService = new NotificationService(defaultServiceOptions());
  if (checkFirstLogin()) {
    await loadNotifications();
  }
});

watch(() => route.fullPath, async (newPath, oldPath) => {
  if (checkFirstLogin()) {
    await loadNotifications();
  }
});

function action() {
  //Mark notification as viewed
  const tmp = notifications.value[notificationIndex.value];
  currentCabinetId.value = getCabinetId();
  currentUserId.value = authStore.userId.value;
  let viewer = { userId: currentUserId.value, cabinetId: currentCabinetId.value };
  notificationService.updateNotificationView(tmp.id, viewer)
    .then(() => {
      //tmp.viewers.push(viewer);
    })
    .catch(err => {
      console.error(err);
      dialog(err);
    });

  // if (notificationIndex.value + 1 < notifications.value.length)
  //   notificationIndex.value++;
  notifications.value.splice(0, 1); //Remove first element from the array
  if (notifications.value?.length > 0) {
    //Continue, display next notification
  }
  else {
    showFirstLoginModal.value = false;
    $router.replace({ query: null });
  }
}

</script>

<template>
  <Modal size="3xl" v-if="showFirstLoginModal && notifications?.length > 0 && notifications[notificationIndex]">
    <template #header>
      <div>
        <div class="flex items-center text-lg">{{ notifications[notificationIndex].title }}</div>
        <div class="text-xs opacity-75">{{ formatDate(notifications[notificationIndex].expectedDate[0]) }} - {{ formatDate(notifications[notificationIndex].expectedDate[1]) }}</div>
      </div>
    </template>
    <template #body>
      <div v-html="notifications[notificationIndex].content"></div>
    </template>
    <template #footer>
      <div class="flex justify-between">
        <div class="flex space-x-2 ml-auto">
          <Button type="primary" @click="action()" class="btn btn-primary">{{ t("confirm", "Potrdi") }}</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>